<template>
  <div class="project-schedules">
    <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">Window Schedule Changelog</h3>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>

          <div
            v-for="version in versions"
            :key="version.published_on"
            class="schedule"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 12 : 0"
                class="pa-1 d-flex justify-space-between cursor-pointer"
                @click="changeVersion(version)"
              >
                <div class="mb-1 mb-sm-0 d-flex">
                  <div class="ml-1">
                    <h6 class="primary--text pb-0 mb-0">
                      <strong>Version {{ version.number }}</strong>
                    </h6>
                    <div class="grey--text">
                      <strong>Published: </strong>
                      {{ new Date(version.published_on).toLocaleString() }}
                    </div>
                    <div class="grey--text">
                      <strong>Change description: </strong> Changed xyz windows
                      on secondary level
                    </div>
                    <v-btn color="grey lighten-4" class="mt-1" depressed
                      >Changelog</v-btn
                    >
                  </div>
                </div>
                <div>
                  <v-menu offset-y left>
                    <template v-slot:activator="{ on }">
                      <transition name="slide-fade" mode="out-in">
                        <v-btn icon v-on="on">
                          <v-icon size="32" color="grey">
                            mdi-dots-horizontal
                          </v-icon>
                        </v-btn>
                      </transition>
                    </template>
                    <!-- <v-list dense>
                      <v-list-item @click="deactivateModal = true">
                        <v-icon size="18" class="mr-1">mdi-account</v-icon>
                        <v-list-item-title>Deactivate</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteModal = true">
                        <v-icon size="18" class="mr-1">mdi-delete</v-icon>
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item>
                    </v-list> -->
                  </v-menu>
                  <div>
                    <v-btn icon>
                      <v-icon size="38" color="grey">
                        mdi-chevron-right
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-hover>
            <v-divider class="ma-1"></v-divider>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    versions: {
      type: Array,
      default: null
    }
  },
  data() {
    return {};
  },
  methods: {
    changeVersion(version) {
      this.$emit("onVersionChange", version);
    }
  }
};
</script>
